import { Input, InputFieldProps } from '@/components/atoms/Input';

import { useScraperTranslations } from '@/blocks/Scraper/scraperTranslations/index';
import { FormFieldProps } from '@/blocks/Scraper/types';

import ScrapeTargetParamIcon from './ScrapeTargetParamIcon';

const QueryField = ({ param, form }: FormFieldProps) => {
  const field = form.getFieldProps(param.key);
  const { getTranslation } = useScraperTranslations();

  return (
    <Input<InputFieldProps>
      as='input'
      autoComplete='off'
      classNames={{
        input: {
          inputElement: 'bg-base-white dark:bg-gray-50',
          root: 'text-gray-950',
        },
        label: {
          root: 'text-left text-body-l-medium dark:text-gray-900',
        },
      }}
      hideBottomText
      label={getTranslation(param.header?.id ?? '')}
      leftIcon={<ScrapeTargetParamIcon param={param} />}
      placeholder=''
      {...field}
      value={String(field.value)}
    />
  );
};

export default QueryField;
